import { render, staticRenderFns } from "./OpenGameRound.vue?vue&type=template&id=59ecd47f&scoped=true&"
import script from "./OpenGameRound.vue?vue&type=script&lang=js&"
export * from "./OpenGameRound.vue?vue&type=script&lang=js&"
import style0 from "./OpenGameRound.vue?vue&type=style&index=0&id=59ecd47f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ecd47f",
  null
  
)

export default component.exports